import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  namespaced: true,
  state() {
    return {
      seasonsList: [
        // {
        //   seasonId: 's1',
        //   year: 2021,
        //   isActive: true,
        //   conferences: [ 'AFC', 'NFC'],
        //   divisions: [ 'North', 'South', 'East', 'West'],
        //   teamsPerDivision: 4,
        //   seasonGamesPerTeam: 17,
        //   regularSeasonWeeks: 18,
        //   seasonStartDate: new Date(2021, 8, 9, 18, 20),
        //   seasonEndDate: new Date(2022, 1, 13),
        //   tournamentStartDate: new Date(2021, 8, 16, 18, 20),
        //   tournamentPickingOpen: true,
        // },
      ],
      currentSeason: {
        seasonId: null,
        year: null,
        isActive: false,
        conferences: null,
        divisions: false,
        teamsPerDivision: null,
        seasonGamesPerTeam: null,
        regularSeasonWeeks: null,
        seasonStartDate: null,
        seasonEndDate: null,
        tournamentStartDate: null,
        tournamentPickingOpen: false,
      }
    };
  },
  mutations,
  actions,
  getters,
};